const AddressEndpoints = {
  cities: 'api/address/cities',
  towns: 'api/address/towns',
  districts: 'api/address/districts',
  warehouses: 'api/address/warehouses',
};

export { AddressEndpoints };
